import React, { useState } from 'react'
import {
    Button,
    Typography,
    Grid,
    Box,
    Menu,
    MenuItem,
    IconButton,
    useMediaQuery,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { NavLink, useNavigate } from 'react-router-dom'
import logo from '../../assets/Images/TMDSAS_Logo_2020.png'
import './dashboardNavbar.css'
import { useEffect } from 'react'
import { toastError, toastSuccess } from '../../util/toastUtil'
import {
    BASE_ROUTE_ENDPOINTS,
    baseURLRoute,
} from '../../constants/routeConstants'

const DashBoardNavbar = (props) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const isMobile = useMediaQuery('(max-width:790px)')

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (route) => {
        setAnchorEl(null)
        if (route) navigate(route)
    }
    let logoutTimer

    const startLogoutTimer = () => {
        logoutTimer = setTimeout(() => {
            logout()
        }, 60 * 60 * 1000) // 60 minutes in milliseconds
    }

    const resetLogoutTimer = () => {
        clearTimeout(logoutTimer)
        startLogoutTimer()
    }

    const handleUserActivity = () => {
        resetLogoutTimer()
    }

    const logout = () => {
        sessionStorage.clear()
        navigate(baseURLRoute, { replace: true })
        toastError('User logged out due to inactivity')
    }

    useEffect(() => {
        startLogoutTimer()

        document.addEventListener('mousemove', handleUserActivity)
        document.addEventListener('keydown', handleUserActivity)
        document.addEventListener('click', handleUserActivity)

        return () => {
            clearTimeout(logoutTimer)
            document.removeEventListener('mousemove', handleUserActivity)
            document.removeEventListener('keydown', handleUserActivity)
            document.removeEventListener('click', handleUserActivity)
        }
    }, [])

    const user = props.user
    const navigate = useNavigate()
    return (
        <nav className="navbar dashboard-navbar">
            {isMobile ? (
                <Grid
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                    }}>
                    <Grid
                        container
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '0.5rem',
                        }}>
                        <Grid item xs={3}>
                            <a
                                className="dashboard-nav-bar-icon-container"
                                onClick={() =>
                                    window.open('https://tmdsas.com', '_blank')
                                }>
                                <img src={logo} height={50} />
                            </a>
                        </Grid>
                        <Grid>
                            <>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    aria-label="menu"
                                    onClick={handleClick}
                                    sx={{ fontSize: '2rem' }}>
                                    <MenuIcon fontSize="large" />
                                </IconButton>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={() => handleClose()}
                                    MenuListProps={{
                                        sx: { bgcolor: '#00B4AC' },
                                    }}>
                                    <MenuItem
                                        onClick={() =>
                                            handleClose(
                                                BASE_ROUTE_ENDPOINTS.DASHBOARD
                                            )
                                        }
                                        sx={{
                                            fontWeight: 'bold',
                                            color: 'white',
                                        }}>
                                        Home
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() =>
                                            handleClose(
                                                BASE_ROUTE_ENDPOINTS.MYACCOUNT
                                            )
                                        }
                                        sx={{
                                            fontWeight: 'bold',
                                            color: 'white',
                                        }}>
                                        My Account
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            sessionStorage.clear()
                                            handleClose(baseURLRoute)
                                        }}
                                        sx={{
                                            fontWeight: 'bold',
                                            color: 'white',
                                        }}>
                                        Logout
                                    </MenuItem>
                                </Menu>
                            </>
                        </Grid>
                    </Grid>
                    <Grid>
                        <Box
                            className="dashboard-navbar-userinfo-container"
                            sx={{
                                backgroundColor: '#f5f5f5',
                                padding: '1rem',
                            }}>
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 'bold' }}>
                                {user ? user.userName : ''}
                            </Typography>
                            <Typography
                                variant="subtitle2"
                                color="textSecondary">
                                TMDSAS ID: {user ? user.userId : ''}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            ) : (
                <Grid container style={{ alignItems: 'center' }}>
                    <Grid item xs={3}>
                        <a
                            className="dashboard-nav-bar-icon-container"
                            onClick={() =>
                                window.open('https://tmdsas.com', '_blank')
                            }>
                            <img src={logo} height={50} />
                        </a>
                    </Grid>
                    <Grid item xs={6}>
                        <Box className="dashboard-navbar-links-container">
                            <Button
                                onClick={() =>
                                    navigate(BASE_ROUTE_ENDPOINTS.DASHBOARD)
                                }
                                className="dashboard-navbar-button"
                                variant="contained"
                                color="primary"
                                sx={{
                                    fontSize: '14px',
                                    marginRight: '1rem',
                                    backgroundColor: '#00B4AC',
                                    ':hover': {
                                        backgroundColor: '#10918C',
                                    },
                                }}>
                                Home
                            </Button>
                            <Button
                                onClick={() =>
                                    navigate(BASE_ROUTE_ENDPOINTS.MYACCOUNT)
                                }
                                className="dashboard-navbar-button"
                                variant="contained"
                                color="primary"
                                sx={{
                                    fontSize: '14px',
                                    marginRight: '1rem',
                                    backgroundColor: '#00B4AC',
                                    ':hover': {
                                        backgroundColor: '#10918C',
                                    },
                                }}>
                                My Account
                            </Button>
                            <Button
                                onClick={() => {
                                    sessionStorage.clear()
                                    navigate(baseURLRoute, { replace: true })
                                }}
                                className="dashboard-navbar-button"
                                variant="contained"
                                color="primary"
                                sx={{
                                    fontSize: '14px',
                                    marginRight: '1rem',
                                    backgroundColor: '#00B4AC',
                                    ':hover': {
                                        backgroundColor: '#10918C',
                                    },
                                }}>
                                Logout
                            </Button>
                        </Box>
                    </Grid>

                    <Grid item xs={3}>
                        <Box
                            className="dashboard-navbar-userinfo-container"
                            sx={{
                                backgroundColor: '#f5f5f5',
                                padding: '1rem',
                            }}>
                            <Typography
                                variant="h6"
                                sx={{ fontWeight: 'bold' }}>
                                {user ? user.userName : ''}
                            </Typography>
                            <Typography
                                variant="subtitle2"
                                color="textSecondary">
                                TMDSAS ID: {user ? user.userId : ''}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            )}
        </nav>
    )
}

export default DashBoardNavbar
